import { readLocalStorage, writeLocalStorage } from '../modules/storage';

const DEPRECATION_NOTICE_LINK =
  'https://help.sap.com/docs/build-apps/service-guide/sap-build-apps-path-forward#migrating-from-the-sap-build-apps-standalone-offering-to-sap-build';

const DEPRECATION_NOTICE_STORAGE_KEY = 'sap.build.apps.deprecation_notice.last_shown_date';

export function hasShownDeprecationNoticeToday(): boolean {
  const lastShown = readLocalStorage<string>(DEPRECATION_NOTICE_STORAGE_KEY, false);
  return lastShown === new Date().toDateString();
}

export function markDeprecationNoticeShownToday() {
  writeLocalStorage(DEPRECATION_NOTICE_STORAGE_KEY, new Date().toDateString(), false);
}

export default DEPRECATION_NOTICE_LINK;
